module.exports = __webpack_public_path__ + "static/CLS-8881a92497715e641846f1c81ea572e7.jpg";